(function ($) {

'use strict';

	/**
	 * Animate the passed element.
	 * The element could optionally define the following attributes:
	 *  "data-animate-duration" integer value to specify the duration. Default: 600
	 *			use "-1" to disable the animation
	 *  "data-animate-easing" string to define an easing effect, see http://easings.net/
	 * @param {function} complete executes after the animation has completed
	 */
	$.fn.animateElement = function (complete) {
		if ($(this).length < 1) {
			return;
		}

		var $elem = $(this);
		// to disable animation use in tpl: ... data-animate-duration="-1" 
		var duration = (parseInt($elem.attr('data-animate-duration')) || 600);

		$elem.fadeTo(duration / 3, 0.4, function () {
			$(this).fadeTo(duration / 2, 1,
					($(this).attr('data-animate-easing') || 'easeInBack'),
					(typeof complete === 'function' ? complete : null));
		});
	};

}(jQuery));